"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationArgPermissions = exports.MutationPermissions = exports.QueryFieldPermissions = exports.QueryPermissions = void 0;
const roles_1 = require("../config/roles");
// permissions for top-level queries
// (nothing here yet, add as needed)
exports.QueryPermissions = {
    surgeString: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
    surgedRoleRates: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
};
// permissions for fields of queries
exports.QueryFieldPermissions = {
    account: {
        userTypeTemplates: [roles_1.Role.TYPE_TEMPLATES],
        report: [roles_1.Role.REPORTS_MY_STAFF, roles_1.Role.REPORTS_PAYROLL],
        reports: [roles_1.Role.REPORTS_MY_STAFF, roles_1.Role.REPORTS_PAYROLL],
    },
    user: {
        typeTemplate: [roles_1.Role.TYPE_TEMPLATES],
    },
    member: {
        state: [roles_1.Role.MEMBERS_STATE],
        bankName: [roles_1.Role.MEMBERS_BANK],
        accountName: [roles_1.Role.MEMBERS_BANK],
        accountNumber: [roles_1.Role.MEMBERS_BANK],
        sortCode: [roles_1.Role.MEMBERS_BANK],
        rollNumber: [roles_1.Role.MEMBERS_BANK],
        annualSalary: [roles_1.Role.MEMBERS_BANK],
        NINumber: [roles_1.Role.MEMBERS_BANK],
        // annualSalary ??
        totalEarnings: [roles_1.Role.MEMBERS_PAY],
        totalPayPeriods: [roles_1.Role.MEMBERS_PAY],
        payPeriods: [roles_1.Role.MEMBERS_PAY],
        logs: [roles_1.Role.MEMBERS_HISTORY],
        documents: [roles_1.Role.MEMBER_COMPLIANCE],
        s3Documents: [roles_1.Role.MEMBER_COMPLIANCE],
    },
    payPeriod: {
        payDay: [roles_1.Role.MEMBERS_PAY],
        totalBasePay: [roles_1.Role.MEMBERS_PAY],
        totalBonusPay: [roles_1.Role.MEMBERS_PAY],
        totalPay: [roles_1.Role.MEMBERS_PAY],
    },
    memberCompany: {
        UTRNumber: [roles_1.Role.MEMBERS_BANK],
        VATRegistrationNumber: [roles_1.Role.MEMBERS_BANK],
        bankName: [roles_1.Role.MEMBERS_BANK],
        accountName: [roles_1.Role.MEMBERS_BANK],
        sortCode: [roles_1.Role.MEMBERS_BANK],
        accountNumber: [roles_1.Role.MEMBERS_BANK],
    },
    ShiftResultSet: {
        bookingCountTotalCost: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
    },
    shift: {
        bookings: [roles_1.Role.SHIFTS_BOOKINGS],
        payRate: [roles_1.Role.SHIFTS_PAY],
        chargeRate: [roles_1.Role.SHIFTS_COST],
        bonuses: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        rewards: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        totalCostBonusesAndRewards: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        logs: [roles_1.Role.SHIFTS_HISTORY],
    },
    booking: {
        payRate: [roles_1.Role.SHIFTS_PAY],
        chargeRate: [roles_1.Role.SHIFTS_COST],
        bonuses: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        rewards: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        totalCostBonusesAndRewards: [roles_1.Role.SHIFTS_PAY, roles_1.Role.SHIFTS_COST],
        logs: [roles_1.Role.BOOKINGS_HISTORY],
    },
    roleRate: {
        payRate: [roles_1.Role.PARTNER_VIEW, roles_1.Role.SHIFTS_PAY],
        chargeRate: [roles_1.Role.PARTNER_VIEW, roles_1.Role.SHIFTS_COST],
    },
    bookingResult: {
        payFinal: [roles_1.Role.SHIFTS_PAY],
        payRateFinal: [roles_1.Role.SHIFTS_PAY],
        costFinal: [roles_1.Role.SHIFTS_COST],
    },
    bookingState: {
        payRate: [roles_1.Role.SHIFTS_PAY],
        payRateFinal: [roles_1.Role.SHIFTS_PAY],
        payFinal: [roles_1.Role.SHIFTS_PAY],
        chargeRate: [roles_1.Role.SHIFTS_COST],
        costFinal: [roles_1.Role.SHIFTS_COST],
    },
};
// permissions for top-level mutations
exports.MutationPermissions = {
    createOrUpdateShift: [roles_1.Role.SHIFTS_CREATE, roles_1.Role.SHIFTS_EDIT],
    approveShift: [roles_1.Role.TIMESHEETS_APPROVAL],
    publishShifts: [roles_1.Role.SHIFTS_PUBLISH],
    generateReport: [roles_1.Role.REPORTS_MY_STAFF, roles_1.Role.REPORTS_PAYROLL_CREATE],
    createUpdateUserTypeTemplate: [
        roles_1.Role.TYPE_TEMPLATE_CREATE,
        roles_1.Role.TYPE_TEMPLATE_EDIT,
    ],
    deleteUserTypeTemplate: [roles_1.Role.TYPE_TEMPLATE_EDIT],
    updateUserTypeTemplate: [roles_1.Role.TYPE_TEMPLATE_ASSIGN],
    createOrUpdateMember: [roles_1.Role.MEMBERS_EDIT],
    updateMemberPhoto: [roles_1.Role.MEMBER_COMPLIANCE_EDIT],
    createOrUpdateBriefing: [
        roles_1.Role.BRIEFING_TEMPLATES_CREATE,
        roles_1.Role.BRIEFING_TEMPLATES_EDIT,
    ],
    createOrUpdateVenues: [roles_1.Role.VENUES_CREATE, roles_1.Role.VENUES_EDIT],
    createOrUpdateUniform: [
        roles_1.Role.UNIFORM_TEMPLATES_CREATE,
        roles_1.Role.UNIFORM_TEMPLATES_EDIT,
    ],
};
// permissions for mutation args
exports.MutationArgPermissions = {
    createOrUpdateMember: {
        state: [roles_1.Role.MEMBERS_STATE_EDIT],
        bankName: [roles_1.Role.MEMBERS_BANK_EDIT],
        accountName: [roles_1.Role.MEMBERS_BANK_EDIT],
        accountNumber: [roles_1.Role.MEMBERS_BANK_EDIT],
        sortCode: [roles_1.Role.MEMBERS_BANK_EDIT],
        rollNumber: [roles_1.Role.MEMBERS_BANK_EDIT],
        NINumber: [roles_1.Role.MEMBERS_BANK_EDIT],
        UTRNumber: [roles_1.Role.MEMBERS_BANK_EDIT],
        VATRegistrationNumber: [roles_1.Role.MEMBERS_BANK_EDIT],
        dbsCertificateNumber: [roles_1.Role.MEMBER_COMPLIANCE_EDIT],
        dbsIssueDate: [roles_1.Role.MEMBER_COMPLIANCE_EDIT],
    },
};
